/**
 * Utility functions for niche-related operations
 */
import { showNotification } from "@/components/notifications/Notifications";

export const SECONDS_IN_DAY = 86400;
export const MINIMUM_ACCOUNT_AGE_DAYS = 10;
export const MS_TO_SECONDS = 1000;

/**
 * Checks if a user is allowed to add content to niches based on their verification status and account age
 * @param verified - Whether the user is verified
 * @param creationtime - The timestamp when the user's account was created (in seconds)
 */
const canAddToNiche = (verified: boolean | undefined, creationtime: number | undefined): boolean => {
  if (verified) {
    return true;
  }

  if (verified === undefined || creationtime === undefined) {
    return false;
  }

  const limit = SECONDS_IN_DAY * MINIMUM_ACCOUNT_AGE_DAYS;
  const accountAge = (Date.now() / MS_TO_SECONDS) - creationtime;

  return accountAge >= limit;
};

export const validateGifSubmission = (verified: boolean | undefined, creationtime: number | undefined): boolean => {
  if (canAddToNiche(verified, creationtime)) {
    return true;
  } else {
    showNotification({
      title: "Unable to add to niche",
      description: "Your RedGIFs account hasn't existed long enough to be able to add to niches yet. See our FAQs for more info.",
      variant: "info",
      actionButton: {
        title: "Go to the FAQ",
        onClick: () => window.open("https://help.redgifs.com/hc/en-us/sections/18029718713745-Niche-Management", "_blank"),
      },
    });
    return false;
  }
};

export const TOP_NICHES = [
  "legal-teens",
  "amateur-girls",
  "real-orgasms",
  "blowjobs",
  "girls-finishing-the-job",
];
